







































import Enumerable from "linq";
import { Component, Mixins, } from "vue-property-decorator";
import { ModelEditableMixin, DialogMixin } from "../../../components/system";
import { DocumentSearchPresetCondition, SearchConditionPresetKinds, } from "../../../domain/document";
import { PresetUpdateArea, PresetDeleteArea, PresetSortArea, } from "./contents";

@Component({
  components: {
    NewArea: PresetUpdateArea,
    UpdateArea: PresetUpdateArea,
    DeleteArea: PresetDeleteArea,
    SortArea: PresetSortArea,
  }
})
export default class  SearchConditionPresetEditDialog extends Mixins(ModelEditableMixin, DialogMixin) {
  data(): any {
    return {
      selectedContent: "",
      presets: [],
      selectedPreset: null,
      quotedPreset: null,
      departmentId: "",
      presetKey: "",
    };
  }
  selectedContent: string;
  presets: DocumentSearchPresetCondition[];
  selectedPreset: DocumentSearchPresetCondition;
  quotedPreset: DocumentSearchPresetCondition;
  departmentId: string;
  presetKey: string;

  selectContent(key: string): void {
    this.selectedContent = key;
  }

  isSelected(key: string): boolean {
    return this.selectedContent === key;
  }

  private get _contents(): { [key in string]: string; } {
    return {
      newArea: "new-area",
      updateArea: "update-area",
      deleteArea: "delete-area",
      sortArea: "sort-area",
    };
  }

  get isNewAreaSelected(): boolean {
    return this.selectedContent === this._contents.newArea;
  }

  get targetPreset(): DocumentSearchPresetCondition {
    return this.isNewAreaSelected
      ? this.quotedPreset
      : this.selectedPreset;
  }

  get isPresetSortable(): boolean {
    // プリセットフィルターキーのプリセットを選択しているときは登録済みプリセットが複数あっても並べ替え不可
    return this.hasKey && this.registeredPresets && this.registeredPresets.length > 1;
  }

  get hasKey(): boolean {
    return this.selectedPreset && !!this.selectedPreset.key;
  }

  get selectedPresetKind(): SearchConditionPresetKinds {
    return this.selectedPreset ? this.selectedPreset.presetKind : null;
  }

  get isPresetEditable(): boolean {
    return this.hasKey &&
      ((this.selectedPresetKind === SearchConditionPresetKinds.Person) ||
       (this.selectedPresetKind === SearchConditionPresetKinds.Department && this.isAdministratorDepartment) ||
       (this.selectedPresetKind === SearchConditionPresetKinds.All && this.isCommonItemEditable));
  }

  get isAdministratorDepartment(): boolean {
    return this.departmentId && Enumerable.from(this.$store.getters.userAuthority.administratorDepartmentIds as string[])
      .any(d => d === this.departmentId);
  }

  get isCommonItemEditable(): boolean {
    return this.$store.getters.userAuthority.commonItemEditable;
  }

  get registeredPresets(): DocumentSearchPresetCondition[] {
    // プリセットフィルターキーのプリセットはmst.Registriesに登録されていなく、keyが無い
    return this.presets.filter(p => !!p.key);
  }

  get shouldSelectDefault(): boolean {
    return this.isNewAreaSelected
      ? this.registeredPresets.length === 0
      : this.registeredPresets.length < 2;
  }

  updateAndClose(key: string): void {
    this.presetKey = key;
    this.isVisible = false;
  }

  createQuotedPreset(): DocumentSearchPresetCondition {
    const preset = new DocumentSearchPresetCondition();
    preset.presetKind = SearchConditionPresetKinds.Person;
    // プリセットが0件の場合の新規登録は必ず初回選択にチェックつける
    preset.isDefaultSelected = (this.registeredPresets.length === 0);
    preset.condition = this.selectedPreset.condition.clone();
    return preset;
  }

  createSelectedPreset(source: DocumentSearchPresetCondition): DocumentSearchPresetCondition {
    const preset = source.clone();
    // プリセットが1件しかない場合の更新登録は必ず初回選択にチェックつける(プリセット0件の場合は更新登録はできない)
    preset.isDefaultSelected = ((this.registeredPresets.length < 2) || preset.isDefaultSelected);
    return preset;
  }

  async show(conditions: DocumentSearchPresetCondition[], selectedCondition: DocumentSearchPresetCondition, departmentId: string): Promise<string> {
    return this.showModal(async () => {
      this.selectedContent = this._contents.newArea;
      this.presetKey = "";
      this.presets = conditions.concat();
      this.selectedPreset = this.createSelectedPreset(selectedCondition);
      this.quotedPreset = this.createQuotedPreset();
      this.departmentId = departmentId;
      await this.waitHidden(true);
      return this.presetKey;
    });
  }

  onPresetUpdated(key: string) {
    this.updateAndClose(key);
  }

  onPresetDeleted() {
    this.updateAndClose(this.selectedPreset.key);
  }

  onOrderSaved() {
    this.updateAndClose(this.selectedPreset.key);
  }
}
